"use client";

import { useRef, useEffect } from "react";

export function HeroVideo() {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const show = () => { video.style.opacity = "1"; };

    // If already ready (cached), show immediately
    if (video.readyState >= 3) {
      show();
      return;
    }

    video.addEventListener("canplay", show);

    // Also try to play in case autoplay was blocked
    video.play().catch(() => {});

    return () => video.removeEventListener("canplay", show);
  }, []);

  return (
    <video
      ref={videoRef}
      autoPlay
      muted
      loop
      playsInline
      preload="auto"
      className="absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-700"
    >
      <source src="/images/homepage/hero-video.mp4" type="video/mp4" />
    </video>
  );
}
